const { encodeHTMLEntities, ImageWithCaptionModel, processText } = require("../helpers");
const removeMd = require('remove-markdown');

module.exports = ({ value }) => {
  const { image, caption, fullCaption } = value;
  const iwcModel = new ImageWithCaptionModel(image, caption, fullCaption, "image with caption");

  const captionHtml = processText(iwcModel.captionText(), caption);
  const fullCaptionHtml = processText(iwcModel.fullCaptionText(), fullCaption);

  return `
    <div class="
      layout/align:start
      layout/flex:column
      layout/width:100%
      ">
      <div class="
        layout/relative
        layout/width:100%
        "
        style="
        --picture--max-height: var(--page-width--layout);
        --landscape--picture--max-height: calc(var(--page-width--layout) * 9 / 16);
        --tall--picture--max-height: calc(var(--page-width--layout) * 3 / 4);
        ">
        <picture class="
          picture
          layout/block
          layout/width:100%
          ">
          <img
            class="
              link/enable
              link/focus
              picture/image
              layout/height:auto
            "
            src="${iwcModel.imageUrl()}"
            alt="${encodeHTMLEntities(removeMd(iwcModel.captionText()) || '')}"
            draggable="false"
            oncontextmenu="return false;"
            role="button"
            loading="lazy"
            data-image-overlay-credit="${encodeHTMLEntities(fullCaptionHtml)}"
            data-image-overlay-item=""
            data-image-overlay-src="${iwcModel.imageUrl()}"
            tabindex="0"
            ontouchstart=""
            onerror="window.MoMA.onImageError(this, 1)"
          />
        </picture>
        <div class="
            $color/alpha:54%
            $typography/baseline:body
            $typography/size:small
            $typography/weight:regular
            layout/margin:top:cap
          ">
          <p class="typography">
            <span
              class="
                layout/block
                balance-text
              ">${captionHtml}</span>
          </p>
        </div>
      </div>
    </div>
  `;
};
